import { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { AlloyButton, ModalContext } from 'cat-ecommerce-alloy';
import WarrantyModalContent from '../WarrantyModalContent';
import ReturnPolicyModalContent from '../ReturnPolicyModalContent';
import styles from './styles.module.scss';
import { DealerLocatorModalWrapper } from '@app/components/dealer-locator-react';
import { useModal } from '@cat-ecom/pcc-components';
import Conditional from '../Conditional';

const WarrantyReturnPolicy = ({
  className = '',
  separatorClassname = '',
  orderId = '',
  hideSeparator = false
}) => {
  const [t] = useTranslation();
  const modalContext = useContext(ModalContext);
  const modal = useModal({
    isRequired: false,
    heading: `${t('CAT_SHOPPING_PREFERENCES_SELECT_STORE')}`,
    backButton: false,
    size: 'md'
  });

  const addWarrantyInfoContentToModal = () => {
    modalContext.addModalWithOptions(
      <WarrantyModalContent
        orderId={orderId}
        openDealerLocator={modal.initiatorProps.onClick}
      />
    );
  };

  const addReturnPolicyContentToModal = () => {
    modalContext.addModalWithOptions(
      <ReturnPolicyModalContent
        orderId={orderId}
        openDealerLocator={modal.initiatorProps.onClick}
      />
    );
  };

  const policies = [
    {
      id: 'warrantyInfoButton',
      buttonClass: 'ps-1 pe-1',
      buttonType: 'ghost',
      buttonSize: 'dynamic',
      translationKey: 'WARRANTY_INFO',
      callbackFunction: addWarrantyInfoContentToModal
    },
    {
      id: 'returnInfoButton',
      buttonClass: 'ps-1 pe-1',
      buttonType: 'ghost',
      buttonSize: 'dynamic',
      translationKey: 'FOOTER_RETURN_POLICY',
      callbackFunction: addReturnPolicyContentToModal
    }
  ];

  const renderSeparator = nextPolicy => {
    if (!nextPolicy || hideSeparator) {
      return null;
    }

    return (
      <div
        className={`d-none d-xl-inline ${styles['product-warranty-returns_separator']} ${separatorClassname}`}
      />
    );
  };

  return (
    <div
      className={`d-flex flex-column flex-xl-row flex-wrap align-items-start align-items-xl-center ${className}`}
    >
      {policies.map((policy, index) => {
        return (
          <Fragment key={`container-${policy.id}`}>
            <AlloyButton
              key={policy.id}
              buttonID={policy.id}
              size={policy.buttonSize}
              buttonType={policy.buttonType}
              addClass={cx(policy.buttonClass, {
                'me-0 me-md-5': hideSeparator
              })}
              onClick={policy.callbackFunction}
            >
              {t(policy.translationKey)}
            </AlloyButton>
            {renderSeparator(policies[index + 1])}
          </Fragment>
        );
      })}
      <DealerLocatorModalWrapper modal={modal} />
    </div>
  );
};
export default WarrantyReturnPolicy;

WarrantyReturnPolicy.propTypes = {
  className: PropTypes.string,
  separatorClassname: PropTypes.string,
  orderId: PropTypes.string,
  hideSeparator: PropTypes.bool
};
